// const navbar = document.querySelector('#navbar2');

// const toggleMenuMobile = function(e) {
// 	this.classList.toggle('is-active');
// 	// navbar.classList.toggle('is-active');
// 	// jQuery(navbar).slideToggle();
// }

// // const toggleSubMenuMobile = function(e) {
// // 	this.classList.toggle('is-active');
// // 	jQuery(navbar.querySelectorAll('[data-dropdown]')).not(this).removeClass('is-active');
// // 	jQuery(navbar.querySelectorAll('.sub-menu')).not(this.nextElementSibling).slideUp().toggleClass('is-active');
// // 	jQuery(this.nextElementSibling).slideToggle();
// // }

// document.querySelector('.hamburger').addEventListener('click', toggleMenuMobile);
// // jQuery('[data-dropdown]').on('click', toggleSubMenuMobile);

/**
 * HIDE / REMOVE TRANSPARENT HEADER (HOMEPAGE)
 */

let scrollPos = 0;
const nav = document.querySelector('.home .SiteHeader');

function checkPosition() {
    let windowY = window.scrollY;
    // console.log(windowY)
    if(windowY > 100){
        // nav.classList.remove('transparent');
        nav.classList.add('active');
    }
    else{
        // nav.classList.add('transparent');
        nav.classList.remove('active');
    }
}

if (typeof (nav) != 'undefined' && nav != null) {
    window.addEventListener('scroll', checkPosition);
}